import type { SupabaseClient } from '@supabase/supabase-js';

export async function getTrustedPartners(balancedSupabase: SupabaseClient) {
	const { data: partners, error } = await balancedSupabase
		.from('partners')
		.select('*')
		.eq('trusted', true);

	if (error) {
		console.error(error);
		return [];
	}
	// shuffle partners
	partners.sort(() => Math.random() - 0.5);
	// limit to 5 partners
	partners.splice(5);
	return partners;
}

export async function getPartners(balancedSupabase: SupabaseClient) {
	const { data: partners, error } = await balancedSupabase
		.from('partners')
		.select('*')
		.eq('promoted', true);
	if (error) {
		console.error(error);
		return [];
	}
	// shuffle partners
	partners.sort(() => Math.random() - 0.5);
	// return only 5 partners
	partners.splice(5);
	return partners;
}
